<template>
  <Head title="Login" />
  <div class="flex items-center justify-center p-6 min-h-screen bg-white" style="
  background: rgba(226, 232, 240, var(--tw-bg-opacity));
  position: fixed;
  z-index: 0;
  width: 100%;
  "></div>

  <div class="bg-white flex rounded-3xl" style="
  height: 90vh;
  background: white;
  width: 100%;
  z-index: 1;
  position: fixed;
  left: 0;
  right: 0;
  margin: auto;
  top: 5vh;

  max-width: 1450px;
  width: 82%;

  display:flex;

  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(255, 255, 255, 0.3) 0px 30px 60px -30px;

  ">
    <div 
    class="future-stories"
    style="
    
    background: url('/cdn/atw/brand/bg.png') 0% 0% / cover;
    width: 650px;
    height: calc(100% - 60px);
    border-radius: 25px;
    margin-top: 30px;
    margin-left: 30px;
    
    "></div>

    <div class="w-full max-w-md flex-1 flex-col justify-center items-center" style="
    left: 0;
    right: 0;
    position: relative;
    height: fit-content;
    top: 0;
    bottom: 0;
    margin: auto;
      ">
      <logo v-if="false" class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h1 class="text-center text-4xl font-semibold text-black">Welcome Back!</h1>
          <p style="width: 100%; text-align: center; padding-top: 10px;  color: #000;">Access your website or the CMR by logging in.</p>
          <div class="mt-6 mx-auto w-24 border-b-2" />
          <text-input v-model="form.email" :error="form.errors.email" class="mt-10 rounded-xl" label="Email" type="email" autofocus autocapitalize="off" />
          <text-input v-model="form.password" :error="form.errors.password" class="mt-6 rounded-xl" label="Password" type="password" />
          <loading-button :loading="form.processing" class="bg-black w-full p-4 text-white text-center rounded-xl mt-4 justify-center ml-auto" type="submit">Login</loading-button>

          <label class="flex items-center mt-6 select-none" for="remember">
            <input id="remember" v-model="form.remember" class="mr-1" type="checkbox" />
            <span class="text-sm">Remember Me</span>
          </label>
        </div>
        <div class="flex px-10 py-4">
          
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/vue3'

import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    LoadingButton,

    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: null,
        password: null,
        remember: false,
      }),
    }
  },
  methods: {
    login() {
      this.form.post('/login')
    },
  },
}
</script>
